import authRequest from 'utils/authRequest'
import studentRequest from 'utils/studentRequest'
import instituteRequest from 'utils/instituteRequest'
import corporateRequest from 'utils/corporateRequest'
import adminRequest from 'utils/adminRequest'
import localRequest from 'utils/localRequest'
import authRequested from 'utils/authRequested'
import { installSessionRefresh } from 'utils/sessionRefresh'
import { SignInSuccess } from 'modules/Auth/actions'

const initApiServices = store => {
  try {
    installSessionRefresh({
      umsRequest: authRequest,
      instances: [
        authRequest,
        studentRequest,
        instituteRequest,
        corporateRequest,
        adminRequest,
        localRequest,
        authRequested,
      ],
      onToken: token => store.dispatch(SignInSuccess(token)),
    })
    authRequest.interceptors.response.use(
      response => {
        return response
      },
      error => {
        // Public (unauthenticated) endpoints — e.g. the assessment invite OTP
        // request/verify/resend — legitimately return 401 for a wrong or expired
        // code. Those must NOT clear the session and reload (that bounces the
        // candidate back to the email step); let the calling component surface
        // the message. Only portal-authenticated 401s mean "session expired".
        const url = error?.config?.url || ''
        const isPublic = url.includes('/public/')
        if (!isPublic && error?.response?.status === 401) {
          localStorage.clear()
          location.reload()
          return new Promise(() => {})
        }
        // Reject with the original axios error so callers can read
        // error.response.data.message (wrapping in new Error() would lose it).
        return Promise.reject(error)
      }
    )
  } catch (e) {
    console.error('Error occurred while logout : in InitApiService', e)
  }
}

export default initApiServices
